import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import CompanyTagFormDialog from '@/views/pages/companyTags/CompanyTagFormDialog.vue';
import CompanyTagDeleteDialog from '@/views/pages/companyTags/CompanyTagDeleteDialog.vue';
import { getColor } from '@/views/pages/companyTags/colors';

import { usePermissionComposable } from '@/composables/usePermission';
import { Tag } from '@/interfaces/model/general/tag';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyTagsTable',
  props: {
    tags: null
  },
  emits: ["dataChanged"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dataChanged'): void;
}), expose: any, slots: any, attrs: any }) {

const m = defineMessages({
  editTag: 'このタグを編集します。',
  deleteTag: 'このタグを削除します',
});

const { hasPermission, PERMISSIONS: P } = usePermissionComposable();




const showTagFormDialog = ref(false);
const showTagDeleteDialog = ref(false);
const selectedTag = ref<Tag>();

const openUpdateDialog = (tag: Tag) => {
  selectedTag.value = { ...tag };
  showTagFormDialog.value = true;
};

const openDeleteDialog = (tag: Tag) => {
  selectedTag.value = { ...tag };
  showTagDeleteDialog.value = true;
};

return { __sfc: true,m, hasPermission, P, emits, showTagFormDialog, showTagDeleteDialog, selectedTag, openUpdateDialog, openDeleteDialog, CompanyTagFormDialog, CompanyTagDeleteDialog, getColor, sharedMessages }
}

})